<ng-container *ngIf="change.changeType === changeType.Unchanged">
    <span class="no-change">{{ requiredTypeChangeOriginalValue | nullDash }}</span>
</ng-container>
<ng-container *ngIf="change.changeType === changeType.Changed">
    <div class="value-panel">
        <span class="original-value">{{ requiredTypeChangeOriginalValue | nullDash }}</span>
        <span class="new-value">{{ requiredTypeChangeNewValue | nullDash }}</span>
    </div>
</ng-container>

<ng-container *ngIf="noteChange && (noteChange.originalValue || noteChange.newValue)">
    <ng-container *ngIf="noteChange.changeType === changeType.Unchanged">
        <div class="note">Note: {{ noteChange.originalValue | nullDash }}</div>
    </ng-container>
    <ng-container *ngIf="noteChange.changeType === changeType.Changed">
        <div class="value-panel note">
            Note: <span class="original-value">{{ noteChange.originalValue | nullDash }}</span>
            <span class="new-value">{{ noteChange.newValue | nullDash }}</span>
        </div>
    </ng-container>
</ng-container>
